export default "__VITE_ASSET__BtH4VctY__"